
$(document).ready(function() {
var header = $('.song-section');
    $(window).scroll(function() {
        var scroll = $(window).scrollTop();
        if (scroll >= 100) {
            header.addClass('active');
        } else {
            header.removeClass('active');
        }
    
	
//	$(".world_banner_2").css("background-position","50%" + ($(this).scrollTop() / 2) + "px");
//$(".world_banner_2").css("background-position","0%" + ($(this).scrollTop() / 2) + "px");
	
	});	
	
	
	$(".smoke-video").hover(function () {
        $(this).children("video")[0].play();
    }, function () {
        var el = $(this).children("video")[0];
        el.pause();
        el.currentTime = 0;
    });
	
	

});

// Check if the element is in the viewport.
// http://www.hnldesign.nl/work/code/check-if-element-is-visible/
function isInViewport(node) {
  // Am I visible? Height and Width are not explicitly necessary in visibility
  // detection, the bottom, right, top and left are the essential checks. If an
  // image is 0x0, it is technically not visible, so it should not be marked as
  // such. That is why either width or height have to be > 0.
  var rect = node.getBoundingClientRect()
  return (
    (rect.height > 0 || rect.width > 0) &&
    rect.bottom >= 0 &&
    rect.right >= 0 &&
    rect.top <= (window.innerHeight || document.documentElement.clientHeight) &&
    rect.left <= (window.innerWidth || document.documentElement.clientWidth)
  )
}








// Note how you feel section animation
  var animation_elements = $.find('.animation-element');
  var web_window = $(window);
  //check to see if any animation containers are currently in view
  function check_if_in_view() {
    //get current window information
    var window_height = web_window.height();
    var window_top_position = web_window.scrollTop();
    var window_bottom_position = window_top_position + window_height - 200;

    //iterate through elements to see if its in view
    $.each(animation_elements, function () {
      //get the element sinformation
      var element = $(this);
      var element_height = $(element).outerHeight();
      var element_top_position = $(element).offset().top;
      var element_bottom_position = element_top_position + element_height + 900;
      //check to see if this current container is visible (its viewable if it exists between the viewable space of the viewport)
      if (element_bottom_position >= window_top_position && element_top_position <= window_bottom_position) {
        element.addClass('in-view');
      } else {
        element.removeClass('in-view');
      }
    });
  }
  //on or scroll, detect elements in view
  $(window).on('scroll resize', function () {
    check_if_in_view();
  });
 

  //trigger our scroll event on initial load
  $(window).trigger('scroll');






// mp3. Music

var musicBtn = document.querySelector("#toggle");
var audio = new Audio(musicBtn.dataset.musicSrc);

function toggleAudio(audioFile) {
  console.log(audioFile.currentTime);
   if(audioFile.paused && audioFile.currentTime > 0 && !audioFile.ended) {
      console.log('asdasdasd');
      audioFile.play();
   } else {
      audioFile.pause();
   }
}

$(document).on('click', '#toggle', function() {
	 $('#music1').css("border", '5px solid red');
	 $("#music1").contents().find(".PreviewPlayButton_iconButton__88VMw").click();
});

$('body').on('click', '#toggle', function() {
  $('#toggle').toggleClass('active');
  if(audio.paused) {
    audio.play();
  } else {
    audio.pause();
  }
});


$('body').on('click', '#world-product', function() {
	$('.world-product_popup').addClass('active');
//	$('body').addClass('hide_scroll');
	$('.over-box').show();
	$('.main-box').addClass('active');
	
});
$('body').on('click', '.close-product_popup, .over-box', function() {
	$('.world-product_popup').removeClass('active');
	//$('body').removeClass('hide_scroll');
	$('.over-box').hide();
	$('.main-box').removeClass('active');
});



if ($(window).width() < 767) {
gsap.registerPlugin(ScrollTrigger);
let sections = gsap.utils.toArray(".panel");
gsap.to(sections, {
  xPercent: -80 * (sections.length - 1),
  ease: "none",
  scrollTrigger: { 
    trigger: "#wrapper",
    pin: true,
    scrub: 1,
    snap: 1 / (sections.length - 1),
    end: () => "+=" + document.querySelector("#wrapper").offsetWidth
  }
});
} else {
	gsap.registerPlugin(ScrollTrigger);
let sections = gsap.utils.toArray(".panel");
gsap.to(sections, {
  xPercent: -55 * (sections.length - 1),
  ease: "none",
  scrollTrigger: { 
    trigger: "#wrapper",
    pin: true,
    scrub: 0,
    snap: 0 / (sections.length - 1),
    end: () => "+=" + document.querySelector("#wrapper").offsetWidth
  }
});
}


/*
$('.popup_row').bind('mousewheel DOMMouseScroll', function(e) {
    var scrollTo = null;
    if (e.type == 'mousewheel') {
        scrollTo = (e.originalEvent.wheelDelta * -1);
    }
    else if (e.type == 'DOMMouseScroll') {
        scrollTo = 40 * e.originalEvent.detail;
    }
    if (scrollTo) {
        e.preventDefault();
        $(this).scrollTop(scrollTo + $(this).scrollTop());
    }
});*/


/*
// debounce from underscore.js

function debounce(func, wait, immediate) {
	var timeout;
	return function() {
		var context = this, args = arguments;
		var later = function() {
			timeout = null;
			if (!immediate) func.apply(context, args);
		};
		var callNow = immediate && !timeout;
		clearTimeout(timeout);
		timeout = setTimeout(later, wait);
		if (callNow) func.apply(context, args);
	};
};

// use x and y mousewheel event data to navigate flickity
function slick_handle_wheel_event(e, slick_instance, slick_is_animating) {
  // do not trigger a slide change if another is being animated
  if (!slick_is_animating) {
    // pick the larger of the two delta magnitudes (x or y) to determine nav direction
    var direction =
      Math.abs(e.deltaX) > Math.abs(e.deltaY) ? e.deltaX : e.deltaY;

    console.log("wheel scroll ", e.deltaX, e.deltaY, direction);

    if (direction > 0) {
      // next slide
      slick_instance.slick("slickNext");
    } else {
      // prev slide
      slick_instance.slick("slickPrev");
    }
  }
}

// debounce the wheel event handling since trackpads can have a lot of inertia
var slick_handle_wheel_event_debounced = debounce( 
  slick_handle_wheel_event
  , 100, true
);

// init slider 
const slick_2 = $("#worldproduct-grid");
slick_2.slick({
  dots: false,
  vertical: true,
  arrows: false,
   infinite: false,
  // verticalSwiping: true,
  arrows: false
});
var slick_2_is_animating = false;

slick_2.on("afterChange", function(index) {
  console.log("Slide after change " + index);
  slick_2_is_animating = false;
});

slick_2.on("beforeChange", function(index) {
  console.log("Slide before change " + index);
  slick_2_is_animating = true;
});

slick_2.on("wheel", function(e) {
  slick_handle_wheel_event_debounced(e.originalEvent, slick_2, slick_2_is_animating);  
});
*/

var s = skrollr.init({
		edgeStrategy: 'set',
		easing: {
			WTF: Math.random,
			inverted: function(p) {
				return 1-p;
			}
		}
	});

// for more grass
(function(){
  function getRndNum(min, max) {
    return Math.round(Math.random() * (max - min)) + min;
  }
  for(let x = 0; x < 120; x += getRndNum(2,6)){
    let rndNum = getRndNum(70,100)
    let el = document.createElement('div');
    el.classList.add('grass');
    el.style.width = rndNum + 'vmin';
    el.style.height = rndNum + 'vmin';
    for (let y = 0; y < 3; y++){
      let blade = document.createElement('div');
      blade.classList.add('grass__blade--' + (y + 1));
      blade.classList.add('grass__blade');
      blade.style.setProperty("animation-delay", x + "0ms");
      el.appendChild(blade);
    }
    el.style.left = x + 'vw';
    document.querySelector('body').appendChild(el);
  }
})();